import { createSelector } from 'reselect';
import { getScopes } from './getScopes';
const TICKETS_WRITE_ACCESS = 'tickets-write';
export const hasTicketsWriteAccess = createSelector([getScopes], scopes => scopes.includes(TICKETS_WRITE_ACCESS));